// extracted by mini-css-extract-plugin
export var cargoInsuranceCards__cardImg = "cargo-insurance-cards-module--cargo-insurance-cards__card-img--b4113";
export var mt0 = "cargo-insurance-cards-module--mt-0--897ed";
export var mt1 = "cargo-insurance-cards-module--mt-1--e2d2a";
export var mt2 = "cargo-insurance-cards-module--mt-2--467b3";
export var mt3 = "cargo-insurance-cards-module--mt-3--cab75";
export var mt4 = "cargo-insurance-cards-module--mt-4--49aa0";
export var mt5 = "cargo-insurance-cards-module--mt-5--9d67b";
export var mt6 = "cargo-insurance-cards-module--mt-6--5b495";